import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_auth/referrals/directory")({
  beforeLoad: () => {
    throw redirect({ to: "/referrals/partner-firms" });
  },
});
